<template>
  <div class="pa-5">
    <v-data-table
      :headers="quotationChangeDetailDataTableHeaders"
      :items="quotationChangeDetailList"
      class="elevation-1"
      :loading="isLoadingQuotationChangeDetail"
      :loading-text="$t('common_get_data')"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      :footer-props="{
        'items-per-page-options': [30, 50, 100],
        'items-per-page-text': $t('item_rows_per_page'),
      }"
      :header-props="headerProps"
      :search="searchQuotationChangeDetail"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>變更作業</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchQuotationChangeDetail"
            append-icon="mdi-magnify"
            :label="$t('point_search_label')"
            single-line
            hide-details
            clearable
          ></v-text-field>
          <v-btn
            color="primary"
            dark
            class="mb-2 ml-8"
            @click="isShowEditQuotationChangeDetailDialog = true"
            :disabled="isAllTextFieldDisable"
          >
            {{ $t('common_new') }}
          </v-btn>
          <v-dialog
            v-model="isShowEditQuotationChangeDetailDialog"
            v-if="isShowEditQuotationChangeDetailDialog"
            fullscreen
            persistent
          >
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ dialogTitleHeader }}</span>
                <v-spacer></v-spacer>
                <v-btn text small @click="closeEditedQuotationChangeDetail" class="mx-2">
                  <v-icon>
                    mdi-close-circle-outline
                  </v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-row class="mt-2">
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotationChangeDetailIndex === -1 ||
                        editedQuotationChangeDetail.IsConfirmQuotationChangeDetail
                    "
                    class="mx-2"
                    @click="confirmQuotationChangeDetail"
                  >
                    {{ $t('quotation_tool_is_confirm_quotation') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotationChangeDetailIndex === -1 ||
                        !editedQuotationChangeDetail.IsConfirmQuotationChangeDetail ||
                        editedQuotationChangeDetail.IsThrow ||
                        editedQuotationChangeDetail.IsInvalid
                    "
                    class="mx-2"
                    @click="throwQuotationChangeDetail"
                  >
                    變更單據
                  </v-btn>
                  <v-btn
                    color="green darken-1"
                    fab
                    small
                    class="mx-2"
                    text
                    @click="saveEditedQuotationChangeDetail"
                    :loading="isLoadingSaveBtn"
                    :disabled="
                      isAllTextFieldDisable ||
                        editedQuotationChangeDetail.IsConfirmQuotationChangeDetail
                    "
                  >
                    <v-icon>
                      mdi-content-save
                    </v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="
                      editedQuotationChangeDetailIndex === -1 ||
                        !editedQuotationChangeDetail.IsConfirmQuotationChangeDetail ||
                        editedQuotationChangeDetail.IsInvalid ||
                        editedQuotationChangeDetail.IsThrow
                    "
                    class="mx-2"
                    @click="invalidQuotationChangeDetail"
                  >
                    {{ $t('quotation_invalid_quotation') }}
                  </v-btn>
                </v-row>
              </v-card-text>
              <v-card-text>
                <v-container>
                  <ValidationObserver ref="quotationChangeDetail">
                    <v-row>
                      <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                        <ValidationProvider
                          :name="$t('point_type')"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <v-autocomplete
                            v-model="editedQuotationChangeDetail.Type"
                            :items="changeDetailTypeList"
                            item-text="Name"
                            item-value="Type"
                            required
                            :loading-text="$t('common_get_data')"
                            :no-data-text="$t('common_no_results')"
                            @keyup.enter="setTypeAutocomplete"
                            ref="typeAutocomplete"
                            :error-messages="errors[0]"
                            @change="changeType"
                            :disabled="isAllTextFieldDisable"
                          >
                            <template v-slot:label>
                              <span class="red--text">
                                <strong>* </strong>
                              </span>
                              {{ $t('point_type') }}
                            </template>
                          </v-autocomplete>
                        </ValidationProvider>
                      </v-col>
                      <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                        <date-picker-set-time
                          :time="editedQuotationChangeDetail.ChangeTime"
                          :dateName="'month_item_change_date'"
                          :isAllTextFieldDisabled="isAllTextFieldDisable"
                          @setDate="setChangeTime"
                          @keyupEnter="focusNextInput"
                        />
                      </v-col>
                    </v-row>
                    <div v-if="editedQuotationChangeDetail.Type === 1">
                      <v-row>
                        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                          <license-plate-combobox
                            :fatherOriginalLicensePlate="
                              editedQuotationChangeDetail.OriginalLicensePlate
                            "
                            refName="licensePlateAutocomplete"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                            @changeLicensePlate="changeLicensePlate"
                            v-if="!editedQuotationChangeDetail.IsThrow"
                          />
                          <v-text-field
                            v-model="editedQuotationChangeDetail.OriginalLicensePlate"
                            :label="$t('change_detail_old_license_plate')"
                            disabled
                            v-else
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                          <ValidationProvider
                            :name="$t('change_detail_license_plate')"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="editedQuotationChangeDetail.LicensePlate"
                              :label="$t('change_detail_license_plate')"
                              :disabled="isAllTextFieldDisable"
                              :error-messages="errors[0]"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                          <v-checkbox
                            v-model="editedQuotationChangeDetail.IsAllChange"
                            :disabled="isAllTextFieldDisable"
                            @click="changeIsAllChange"
                          >
                            <template v-slot:label>
                              是否變更全部
                              <v-tooltip right v-if="!editedQuotationChangeDetail.IsAllChange">
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon class="ml-3" color="error" v-bind="attrs" v-on="on">
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <span>僅更新【履歷卡、月租、折扣、預繳】，其他單據不做變更</span>
                              </v-tooltip>
                            </template>
                          </v-checkbox>
                        </v-col>
                      </v-row>
                    </div>
                    <div v-else>
                      <v-row>
                        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                          <customer-autocomplete-for-change-detail
                            refName="customerAutocomplete"
                            :fatherEditedCustomer="editedQuotationChangeDetail.OriginalCustomer"
                            :customerName="'change_detail_old_customer_number'"
                            @setCustomer="setOriginalCustomer"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                          />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                          <license-plate-combobox-by-customer-id
                            v-if="!editedQuotationChangeDetail.IsThrow"
                            :customerId="editedQuotationChangeDetail.OriginalCustomer.Id"
                            :fatherLicensePlateList="editedQuotationChangeDetail.LicensePlateList"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                            @setLicensePlate="setLicensePlateList"
                          />
                          <v-text-field
                            v-model="editedQuotationChangeDetail.LicensePlateList"
                            disabled
                            :label="$t('change_detail_license_plates')"
                            v-else
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="4" md="4" lg="4" xl="4">
                          <customer-autocomplete-for-change-detail
                            refName="customerAutocomplete"
                            :fatherEditedCustomer="editedQuotationChangeDetail.Customer"
                            :customerName="'change_detail_customer_number'"
                            @setCustomer="setCustomer"
                            :isAllTextFieldDisable="isAllTextFieldDisable"
                          />
                        </v-col>
                      </v-row>
                    </div>
                  </ValidationObserver>
                </v-container>
              </v-card-text>
              <v-tabs>
                <v-tab
                  href="#tab-1"
                  v-if="
                    editedQuotationChangeDetail.Type === 1 &&
                      !editedQuotationChangeDetail.IsAllChange
                  "
                >
                  變更硬體品項清單
                </v-tab>
                <v-tab
                  href="#tab-2"
                  v-if="
                    editedQuotationChangeDetail.Type === 1 &&
                      !editedQuotationChangeDetail.IsAllChange
                  "
                >
                  變更月租品項清單
                </v-tab>
                <v-tab
                  href="#tab-3"
                  v-if="
                    editedQuotationChangeDetail.ChangeDetailRecord &&
                      editedQuotationChangeDetail.ChangeDetailRecord.length > 0
                  "
                >
                  需變更單據
                </v-tab>
                <v-tab-item
                  value="tab-1"
                  v-if="
                    editedQuotationChangeDetail.Type === 1 &&
                      !editedQuotationChangeDetail.IsAllChange
                  "
                >
                  <v-card flat>
                    <change-detail-resume-item
                      :resumeList="editedQuotationChangeDetail.ResumeItems"
                      :isAllTextFieldDisable="isAllTextFieldDisable"
                      @confirmDeleteResumeItem="confirmDeleteResumeItem"
                    />
                  </v-card>
                </v-tab-item>
                <v-tab-item
                  value="tab-2"
                  v-if="
                    editedQuotationChangeDetail.Type === 1 &&
                      !editedQuotationChangeDetail.IsAllChange
                  "
                >
                  <v-card flat>
                    <change-detail-month-item
                      :monthList="editedQuotationChangeDetail.MonthItems"
                      :isAllTextFieldDisable="isAllTextFieldDisable"
                      :isOverage="true"
                      @confirmDeleteMonthItem="confirmDeleteMonthItem"
                    />
                  </v-card>
                </v-tab-item>
                <v-tab-item
                  value="tab-3"
                  v-if="
                    editedQuotationChangeDetail.ChangeDetailRecord &&
                      editedQuotationChangeDetail.ChangeDetailRecord.length > 0
                  "
                >
                  <v-card flat>
                    <v-data-table
                      :headers="changeDetailRecordDataTableHeaders"
                      :items="editedQuotationChangeDetail.ChangeDetailRecord"
                      class="elevation-1 ma-5"
                      :loading-text="$t('common_get_data')"
                      :no-data-text="$t('common_no_data')"
                      :no-results-text="$t('common_no_results')"
                      :header-props="headerProps"
                      disable-pagination
                      hide-default-footer
                      :item-class="isOutOfWarrantyClass"
                    >
                      <template v-slot:[`item.Type`]="{ item }">
                        {{ turnFormNumberType(item.Type) }}
                      </template>
                      <template v-slot:[`item.Status`]="{ item }">
                        {{ turnFormStatus(item.Status) }}
                      </template>
                    </v-data-table>
                  </v-card>
                </v-tab-item>
              </v-tabs>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="red darken-1"
                  text
                  @click="closeEditedQuotationChangeDetail"
                  :disabled="isLoadingSaveBtn"
                >
                  {{ $t('common_cancel') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <delete-dialog
            :isAllTextFieldDisable="isAllTextFieldDisable"
            :isLoadingSaveBtn="isLoadingDeleteBtn"
            :isShowDeleteDialog="isShowDeleteQuotationChangeDetailDialog"
            :deleteMessage="'change_detail_delete_message'"
            @closeDelete="closeDeleteQuotationChangeDetail"
            @confirmDelete="confirmDeleteQuotationChangeDetail"
          />
        </v-toolbar>
      </template>
      <template v-slot:[`item.ChangeTime`]="{ item }">
        {{ convertToDateTimeFormat(item.ChangeTime) }}
      </template>
      <template v-slot:[`item.Type`]="{ item }">
        {{ turnFormType(item.Type) }}
      </template>
      <template v-slot:[`item.Edit`]="{ item }">
        <v-btn
          v-if="!item.IsThrow && !item.IsInvalid && !item.IsConfirmQuotationChangeDetail"
          icon
          small
          @click="isShowEditQuotationChangeDetailBtn(item)"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn v-else icon small @click="isShowEditQuotationChangeDetailBtn(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
        <v-btn
          v-if="!item.IsThrow && !item.IsInvalid && !item.IsConfirmQuotationChangeDetail"
          icon
          small
          @click="isShowDeleteQuotationChangeDetailBtn(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
      <template v-slot:[`item.Status`]="{ item }">
        {{ turnFormStatus(item.Status) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {
  HttpQuotationChangeDetail,
  HttpMonth,
  HttpChangeDetail,
  HttpResume
} from '@/js/http-Manager'
import { ChangeDetailType } from '@/js/ChangeDetailType'
import DeleteDialog from '@/components/DeleteDialog.vue'
import CustomerAutocompleteForChangeDetail from '@/components/ChangeDetail/CustomerAutocompleteForChangeDetail.vue'
import DatePickerSetTime from '@/components/DatePickerSetTime.vue'
import { NumberType } from '@/js/NumberType'
import { ThrowStatus } from '@/js/ThrowStatus'
import ChangeDetailMonthItem from '@/components/ChangeDetail/ChangeDetailMonthItem.vue'
import ChangeDetailResumeItem from '@/components/ChangeDetail/ChangeDetailResumeItem.vue'
import LicensePlateComboboxByCustomerId from '@/components/ChangeDetail/LicensePlateComboboxByCustomerId.vue'
import LicensePlateCombobox from '@/components/ChangeDetail/LicensePlateCombobox.vue'

export default {
  name: 'QuotationChangeDetail',
  components: {
    DeleteDialog,
    CustomerAutocompleteForChangeDetail,
    DatePickerSetTime,
    ChangeDetailMonthItem,
    ChangeDetailResumeItem,
    LicensePlateComboboxByCustomerId,
    LicensePlateCombobox
  },
  data: () => ({
    isShowEditQuotationChangeDetailDialog: false,
    quotationChangeDetailList: [],
    editedQuotationChangeDetailIndex: -1,
    searchQuotationChangeDetail: '',
    editedQuotationChangeDetail: {
      Number: '',
      Type: 1,
      IsConfirmQuotationChangeDetail: false,
      LicensePlate: '',
      ChangeTime: 0,
      OriginalLicensePlate: '',
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      OriginalCustomer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      LicensePlateList: [],
      IsThrow: false,
      Status: 0,
      IsInvalid: false,
      InvalidTime: 0,
      InvalidBy: '',
      ChangeDetailRecord: [],
      IsAllChange: true,
      MonthItems: [],
      ResumeItems: []
    },
    defaultQuotationChangeDetail: {
      Number: '',
      Type: 1,
      IsConfirmQuotationChangeDetail: false,
      LicensePlate: '',
      ChangeTime: 0,
      OriginalLicensePlate: '',
      Customer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      OriginalCustomer: {
        Number: '',
        ShortName: '',
        Tel: '',
        Fax: '',
        Attribute: '',
        InvoiceAddress: '',
        CurrencyNo: '',
        InvoiceType: ''
      },
      LicensePlateList: [],
      IsThrow: false,
      Status: 0,
      IsInvalid: false,
      InvalidTime: 0,
      InvalidBy: '',
      ChangeDetailRecord: [],
      IsAllChange: true,
      MonthItems: [],
      ResumeItems: []
    },
    isLoadingQuotationChangeDetail: true,
    isLoadingSaveBtn: false,
    isAllTextFieldDisable: false,
    isShowDeleteQuotationChangeDetailDialog: false,
    isLoadingDeleteBtn: false,
    isDeleteBtnDisable: false,
    changeDetailTypeList: []
  }),
  async mounted () {
    this.getAllQuotationChangeDetail()
    this.getAllChangeDetailType()
  },
  computed: {
    quotationChangeDetailDataTableHeaders () {
      return [
        {
          text: this.$t('point_type'),
          align: 'start',
          value: 'Type'
        },
        { text: '單號', align: 'start', value: 'Number' },
        { text: this.$t('month_item_change_date'), align: 'start', value: 'ChangeTime' },
        {
          text: this.$t('change_detail_old_license_plate'),
          align: 'start',
          value: 'OriginalLicensePlate'
        },
        {
          text: this.$t('change_detail_license_plate'),
          align: 'start',
          value: 'LicensePlate'
        },
        {
          text: this.$t('change_detail_old_customer_number'),
          align: 'start',
          value: 'OriginalCustomer.Number'
        },
        {
          text: this.$t('change_detail_old_customer_short_name'),
          align: 'start',
          value: 'OriginalCustomer.ShortName'
        },
        {
          text: this.$t('change_detail_old_customer_full_name'),
          align: 'start',
          value: 'OriginalCustomer.FullName'
        },
        {
          text: this.$t('change_detail_customer_number'),
          align: 'start',
          value: 'Customer.Number'
        },
        {
          text: this.$t('change_detail_customer_short_name'),
          align: 'start',
          value: 'Customer.ShortName'
        },
        {
          text: this.$t('change_detail_customer_full_name'),
          align: 'start',
          value: 'Customer.FullName'
        },

        {
          text: this.$t('change_detail_license_plates'),
          align: 'start',
          value: 'LicensePlateList',
          sortable: false
        },
        {
          text: this.$t('common_status'),
          align: 'center',
          value: 'Status',
          sortable: false
        },
        {
          text: this.$t('common_edit'),
          align: 'center',
          value: 'Edit',
          sortable: false
        }
      ]
    },
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    turnFormTypeName () {
      return ChangeDetailType.ChangeDetailTypeName(this.editedQuotationChangeDetail.Type)
    },
    dialogTitleHeader () {
      return this.editedQuotationChangeDetailIndex === -1
        ? this.$t('common_new')
        : this.$t('common_edit')
    },
    changeDetailRecordDataTableHeaders () {
      return [
        { text: this.$t('engineer_number_type'), align: 'start', value: 'Type' },
        { text: '唯一值', align: 'start', value: 'Number' },
        { text: this.$t('quotation_license_plate'), align: 'start', value: 'LicensePlate' },
        { text: '錯誤訊息', align: 'start', value: 'ErrorMessage' },
        { text: this.$t('common_status'), align: 'start', value: 'Status' }
      ]
    }
  },
  methods: {
    isOutOfWarrantyClass (item) {
      if (item.Status === 2) {
        return 'red'
      }
    },
    async throwQuotationChangeDetail () {
      await HttpQuotationChangeDetail.ThrowQuotationChangeDetail(this.editedQuotationChangeDetail)
      this.closeEditedQuotationChangeDetail()
      await this.getAllQuotationChangeDetail()
    },
    changeType () {
      let tempType = this.editedQuotationChangeDetail.Type
      this.editedQuotationChangeDetail = JSON.parse(
        JSON.stringify(this.defaultQuotationChangeDetail)
      )
      this.editedQuotationChangeDetail.Type = tempType
    },
    setTypeAutocomplete (event) {
      this.$refs.typeAutocomplete.isMenuActive = false
      this.$refs.typeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },

    async getAllChangeDetailType () {
      let response = await HttpChangeDetail.GetChangeDetailTypes()

      this.changeDetailTypeList = response.status === 200 ? response.data.Data : []
    },
    turnFormType (val) {
      return ChangeDetailType.ChangeDetailTypeName(val)
    },
    turnFormNumberType (val) {
      return NumberType.NumberTypeName(val)
    },
    turnFormStatus (val) {
      return ThrowStatus.ThrowStatusName(val)
    },
    async getAllQuotationChangeDetail () {
      this.isLoadingQuotationChangeDetail = true

      let response = await HttpQuotationChangeDetail.GetQuotationChangeDetails()
      this.isLoadingQuotationChangeDetail = false
      if (response) {
        this.quotationChangeDetailList = response.status === 200 ? response.data.Data : []
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditQuotationChangeDetailBtn (item) {
      this.editedQuotationChangeDetailIndex = this.quotationChangeDetailList.indexOf(item)
      this.editedQuotationChangeDetail = JSON.parse(JSON.stringify(item))
      if (item.IsThrow || item.IsConfirmQuotationChangeDetail || item.IsInvalid) {
        this.isAllTextFieldDisable = true
      }
      this.isShowEditQuotationChangeDetailDialog = true
    },
    closeEditedQuotationChangeDetail () {
      this.isShowEditQuotationChangeDetailDialog = false
      this.isLoadingSaveBtn = false
      this.isAllTextFieldDisable = false

      this.$nextTick(() => {
        this.editedQuotationChangeDetail = JSON.parse(
          JSON.stringify(this.defaultQuotationChangeDetail)
        )
        this.editedQuotationChangeDetailIndex = -1
      })
    },

    async saveEditedQuotationChangeDetail () {
      let isError = false
      if (this.editedQuotationChangeDetail.Type === 1) {
        let response = await HttpMonth.GetMonthExistLicensePlateError(
          this.editedQuotationChangeDetail
        )
        if (response && response.status === 200) {
          let errorList = response.data.Data
          if (errorList.length > 0) {
            isError = true
            alert(errorList.join('\n'))
          }
        }
      }
      if (!isError) {
        const isValid = await this.$refs.quotationChangeDetail.validate()
        if (isValid) {
          this.isLoadingSaveBtn = true
          this.isAllTextFieldDisable = true
          this.isLoadingQuotationChangeDetail = true

          if (this.editedQuotationChangeDetailIndex !== -1) {
            await HttpQuotationChangeDetail.UpdateQuotationChangeDetail(
              this.editedQuotationChangeDetail
            )
          } else {
            await HttpQuotationChangeDetail.AddQuotationChangeDetail(
              this.editedQuotationChangeDetail
            )
          }
          await this.getAllQuotationChangeDetail()
          this.closeEditedQuotationChangeDetail()
        }
      }
    },
    isShowDeleteQuotationChangeDetailBtn (item) {
      this.editedQuotationChangeDetailIndex = this.quotationChangeDetailList.indexOf(item)
      this.isShowDeleteQuotationChangeDetailDialog = true
    },
    async confirmDeleteQuotationChangeDetail () {
      this.isLoadingDeleteBtn = true
      this.isDeleteBtnDisable = true
      this.isLoadingQuotationChangeDetail = true
      await HttpQuotationChangeDetail.DeleteQuotationChangeDetail(
        this.quotationChangeDetailList[this.editedQuotationChangeDetailIndex].Id
      )
      this.isLoadingDeleteBtn = false
      this.isDeleteBtnDisable = false
      this.isLoadingQuotationChangeDetail = false
      await this.getAllQuotationChangeDetail()
      this.closeDeleteQuotationChangeDetail()
    },

    closeDeleteQuotationChangeDetail () {
      this.isShowDeleteQuotationChangeDetailDialog = false
      this.$nextTick(() => {
        this.editedQuotationChangeDetailIndex = -1
      })
    },
    setOriginalCustomer (val) {
      this.editedQuotationChangeDetail.OriginalCustomer = JSON.parse(JSON.stringify(val))
    },
    setCustomer (val) {
      this.editedQuotationChangeDetail.Customer = JSON.parse(JSON.stringify(val))
    },
    setLicensePlateList (val) {
      this.editedQuotationChangeDetail.LicensePlateList = val
    },
    async changeLicensePlate (val) {
      this.editedQuotationChangeDetail.OriginalLicensePlate = val
      await this.changeIsAllChange()
    },
    setChangeTime (val) {
      this.editedQuotationChangeDetail.ChangeTime = val * 1
    },
    async invalidQuotationChangeDetail () {
      this.editedQuotationChangeDetail.IsInvalid = true
      await HttpQuotationChangeDetail.UpdateQuotationChangeDetail(this.editedQuotationChangeDetail)
      this.closeEditedQuotationChangeDetail()
      await this.getAllQuotationChangeDetail()
    },
    async confirmQuotationChangeDetail () {
      this.editedQuotationChangeDetail.IsConfirmQuotationChangeDetail = true
      await HttpQuotationChangeDetail.UpdateQuotationChangeDetail(this.editedQuotationChangeDetail)
      this.closeEditedQuotationChangeDetail()
      await this.getAllQuotationChangeDetail()
    },
    async changeIsAllChange () {
      if (
        !this.editedQuotationChangeDetail.IsAllChange &&
        this.editedQuotationChangeDetail.OriginalLicensePlate
      ) {
        await this.getOriginalLicensePlateResumeList()
        await this.getOriginalLicensePlateMonthList()
      } else {
        this.editedQuotationChangeDetail.MonthItems = []
        this.editedQuotationChangeDetail.ResumeItems = []
      }
    },
    async getOriginalLicensePlateResumeList () {
      let param = {
        licensePlate: this.editedQuotationChangeDetail.OriginalLicensePlate
      }
      let itemResponse = await HttpResume.GetResumeByLicensePlate(param)
      if (itemResponse && itemResponse.status === 200) {
        this.editedQuotationChangeDetail.ResumeItems = []
        itemResponse.data.Data.ResumeItems.forEach((element) => {
          if (!element.IsRemoved) {
            element.Id = element.ItemId
            this.editedQuotationChangeDetail.ResumeItems.push(element)
          }
        })
      }
    },
    async getOriginalLicensePlateMonthList () {
      let param = {
        licensePlate: this.editedQuotationChangeDetail.OriginalLicensePlate
      }
      let monthResponse = await HttpMonth.GetMonthListByLicensePlate(param)
      if (monthResponse && monthResponse.status === 200) {
        this.editedQuotationChangeDetail.MonthItems = []
        monthResponse.data.Data.forEach((element) => {
          if (element.MonthStatus === 1) {
            let temp = {
              Id: element.ItemId,
              Number: element.ItemNumber,
              Name: element.ItemName,
              MonthNumber: element.Number,
              Unit: element.ItemUnit,
              DiscountPrice: element.OriginalCurrency * 1,
              Discount: 0,
              Quantity: element.OverageMonthQuantity * 1,
              RentQuantity: 1,
              Price: element.OriginalCurrency * 1,
              TotalPrice: element.OverageMonthQuantity * element.OriginalCurrency * 1,
              RentWarrantyPeriod: element.RentWarrantyPeriod * 1,
              PayType: element.PayType,
              Remark: element.Remark
            }
            this.editedQuotationChangeDetail.MonthItems.push(temp)
          }
        })
      }
    },
    confirmDeleteMonthItem (item) {
      let index = this.editedQuotationChangeDetail.MonthItems.indexOf(item)
      this.editedQuotationChangeDetail.MonthItems.splice(index, 1)
    },
    confirmDeleteResumeItem (item) {
      this.editedQuotationChangeDetail.ResumeItems.splice(item.Index, 1)
    }
  }
}
</script>
